// @ts-nocheck
import React, { useState, useEffect } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import Gravatar from 'react-gravatar';
import FormattedDate from '../../common/FormattedDate';
import Loading from '../../common/Loading';
import { NavLink } from 'react-router-dom';
import UserPopup from '../../popups/user';
import domainObjects from '../domainObjects';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import icons from '../../../constants/icons';
import NavColours from '../../../constants/NavColours';

export interface AuditsProps {
  id: string;
  getAudit: () => Promise<unknown>;
  cancel: () => void;
  done: () => void;
  addAudit?: () => void;
  reload?: unknown;
}

function Audits({ done, cancel, id, getAudit, addAudit, reload }: AuditsProps) {
  const { t } = useTranslation();
  const [audits, setAudits] = useState();
  const [error, setError] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState();

  const resolveUrl = (item) => {
    if (item.domainId === id) {
      return undefined;
    }

    switch (item.domainObject) {
      case domainObjects.Company:
        return `/company/${item.domainId}`;
      case domainObjects.Game:
        return `/game/${item.domainId}`;
      case domainObjects.Sku:
        return `/sku/${item.domainId}`;
      default:
        return undefined;
    }
  };

  var lastClass = '';
  var colourIndex = 0;
  var maxColourIndex = 12;
  const resolveColour = (item) => {
    if (item.auditTypeCssClasses !== lastClass) {
      lastClass = item.auditTypeCssClasses;
      colourIndex++;
    }
    if (colourIndex > maxColourIndex) {
      colourIndex = 1;
    }
    return NavColours[`NAV_COLOUR_${colourIndex}`];
  };

  const resolveIcon = (item) => {
    switch (item.auditTypeCssClasses) {
      case 'access-granted':
        return icons.SUCCESS;
      case 'account-revoked':
        return icons.DISABLED;
      case 'approved':
        return icons.APPROVE;
      case 'archived':
        return icons.ARCHIVED;
      case 'auto-replenish':
        return icons.REPLENISH;
      case 'comment':
        return icons.APP_ID;
      case 'created':
        return icons.ADD;
      case 'deactivated':
        return icons.DISABLED;
      case 'declined':
        return icons.DECLINE;
      case 'deleted':
        return icons.DELETE;
      case 'download':
        return icons.DOWNLOAD;
      case 'edited':
        return icons.EDIT;
      case 'keys-deactivated':
        return icons.KEY_DISABLED;
      case 'password-reset':
        return icons.RETRY;
      case 'replenish':
        return icons.ADD;
      case 'request-made':
        return icons.REQUEST_KEYS;
      case 'reset':
        return icons.WITHDRAW_REQUEST;
      case 'upload-activation':
        return icons.UPLOAD;
      case 'upload-activations':
        return icons.UPLOAD;
      case 'upload-keys':
        return icons.UPLOAD_KEYS;
      default:
        return undefined;
    }
  };

  useEffect(() => {
    setError(false);
    setLoadingMessage(undefined);
    getAudit(id)
      .then((d) => setAudits(d))
      .catch((e) => {
        setError(true);
        setLoadingMessage(e.message);
      });
  }, [id, getAudit, setAudits, reload, setError, setLoadingMessage]);

  return (
    <SlideoutLayout
      title={t('Audit history')}
      cancel={cancel}
      done={done}
      bar={
        <button className="btn btn-default" onClick={addAudit}>
          {t('Add comment')}
        </button>
      }
    >
      {audits ? (
        audits.length > 0 ? (
          <div className="audit-trail">
            {audits.map((item, index) => (
              <article
                key={item.id}
                className={`audit-item ${index % 2 ? 'alt' : ''}`}
              >
                <div className="audit-item__body">
                  <div className="audit-item__entry">
                    <div className="audit-item__icon">
                      <Gravatar
                        email={item.createdByUsername}
                        size={52}
                        rating="pg"
                        default="retro"
                        className="img-circle float-left"
                        style={{
                          border: '2px solid #ffffff',
                          overflow: 'hidden',
                        }}
                      />
                      <FontAwesomeIcon
                        icon={resolveIcon(item)}
                        fixedWidth
                        size="lg"
                        className={resolveColour(item)}
                      />
                    </div>
                    <div className="panel kw-panel has-buttons r-corners">
                      <header className="mb-2">
                        <div className="valign-container clearfix width-100">
                          <h3 className="audit-item__title valign bold">
                            {item.auditType}
                          </h3>
                          {resolveUrl(item) && (
                            <NavLink
                              to={resolveUrl(item)}
                              className="float-end"
                              title={t('View related item')}
                              onClick={cancel}
                            >
                              <FontAwesomeIcon icon={icons.LINK} />
                            </NavLink>
                          )}
                        </div>
                      </header>
                      <p className="monospace">{item.message}</p>
                      <div className="d-flex justify-content-between mt-3">
                        <i>
                          <UserPopup id={item.createdById}>
                            <span>
                              <NavLink
                                to={`/user/${item.createdById}`}
                                onClick={cancel}
                              >
                                {item.createdByFullName}
                              </NavLink>
                            </span>
                          </UserPopup>
                        </i>
                        <FormattedDate value={item.created} variant="noHtml" />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <p>{t('No audits')}</p>
        )
      ) : (
        <Loading isError={error} message={loadingMessage}></Loading>
      )}
    </SlideoutLayout>
  );
}

export default Audits;
